export function removeSymbolsFromFileName(inputString: string) {
	return inputString.replace(/[*./]/g, '');
}
